import { render, staticRenderFns } from "./DatosProspectoInstitucion.vue?vue&type=template&id=181caeb6"
import script from "./DatosProspectoInstitucion.vue?vue&type=script&lang=js"
export * from "./DatosProspectoInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports